function normalizeCell(value) {
  return String(value).trim().replace(/,/g, ".");
}

function isNumericValue(value) {
  return value !== "" && Number.isFinite(Number(value));
}

export function parseListeningClipboard(text, frequencyCount, intensityCount) {
  const lines = String(text ?? "")
    .replace(/\r\n?/g, "\n")
    .replace(/\n+$/, "")
    .split("\n");
  const values = lines.map((line) => line.split("\t").map(normalizeCell));

  if (values.some((row) => row.some((value) => !isNumericValue(value)))) {
    return {
      error: "Wklejane dane muszą zawierać wyłącznie wartości liczbowe.",
    };
  }

  if (values.length === 1 && values[0].length === 1) {
    return { kind: "single", value: values[0][0] };
  }

  const hasExpectedDimensions =
    values.length === frequencyCount &&
    values.every((row) => row.length === intensityCount);

  if (!hasExpectedDimensions) {
    return {
      error:
        `Wklej jedną wartość albo macierz ${frequencyCount} × ` +
        `${intensityCount} (częstotliwości × intensywności).`,
    };
  }

  return { kind: "matrix", values };
}
